export const PERFORMANCE_MEASURE = 'PERFORMANCE_MEASURE';

export const reportMeasureEntry = (entry = {}) => ({
  type: PERFORMANCE_MEASURE,
  payload: {
    event: PERFORMANCE_MEASURE,
    properties: entry
  }
});



// WEBPACK FOOTER //
// ./js/actions/performance.js